<template lang="html">
  <div class="home bg-gray"  style="padding-bottom:100px;">
    <transition name="right">
    <div class="" v-if="order">
      <div class="wapper product" style="margin-bottom:5px;">
        <h3>订单商品</h3>
        <div class="" v-for="item in order.product" :key="item.id">
          <div class="cart-info" >
            <div class="img">
              <img :src="item.fields.banner" alt="">
            </div>
            <div class="title">
              {{item.fields.title}}
            </div>
          </div>
          <p class="tit border-bottom" style="padding-bottom:16px;margin-bottom:10px;">{{item.fields.subtitle}}</p>
          <p class="order-tit">订单编号: {{order.order_no}}</p>
          <p class="order-tit">下单时间: {{order.created_at}}</p>
          <p class="order-tit" v-if="order.pay_at">支付时间: {{order.pay_at}}</p>
        </div>
      </div>

      <div class="user-num"  v-if="order.other_status > 2">
        恭喜您已成为此款车的第<span>{{order.index}}</span>位车主
      </div>

      <div class="pay-user-message">
        <div class="pum-min">
          <span class="tit">订购人姓名:</span>
          <p class="content">{{order.custom_name}}</p>
        </div>
        <div class="pum-min">
          <span class="tit">订购人手机:</span>
          <p class="content">{{order.custom_phone}}</p>
        </div>
        <div class="pum-min">
          <span class="tit">备注:</span>
          <p class="content">{{order.remark}}</p>
        </div>
      </div>

      <div class="process-max">
        <h3>预定流程:</h3>
        <process :isShow="order.other_status"></process>
        <h3>接下来您需要做的是：</h3>
        <p class="content">
          {{remarkFil(order.other_status)}}
        </p>
      </div>

      <div class="tel-max">
        <div class="txt">
          有任何相关问题<br>都可联系客服为您一站式解决
        </div>
        <button type="button" name="button" @click="telBtn">
          <i></i>
          呼叫我的客服
        </button>
      </div>
      <div class="pay-btn order-btn" v-show="order.is_closed * 1 === 0">
        <button type="button" name="button" @click="onCancleClick" v-if="order.other_status < 3">取消订单</button>
        <button type="button" name="button" @click="goAdditionalInfo" class="pay" v-show="order.buyer_information.id * 1 !== 0">查看车主资料</button>
        <button type="button" name="button" @click="goAdditionalInfo" class="pay" v-show="order.pay_status * 1 === 1 && order.is_closed * 1 === 0 && order.buyer_information.id * 1 === 0">补全车主资料</button>
        <button type="button" name="button" @click="goPayPage" class="pay" v-show="order.is_closed * 1 === 0 && order.status * 1 === 0">立即支付</button>
      </div>
    </div>
    </transition>

    <confirm v-model="show"
      :title="'确认要取消订单吗'"
      @on-confirm="onConfirm"
      confirm-text="取消订单"
      cancel-text="放弃取消"
      hide-on-blur
      class="toast">
        <p class="toast-txt">一旦取消,订单将无法恢复</p>
      </confirm>

      <toast v-model="showMsg" type="text" :time="800" is-show-mask :position="'middle'">{{msgTxt}}</toast>
  </div>
</template>

<script>
import OrderService from '../../service/OrderService'
import Process from './process.vue'
import Confirm from 'vux/src/components/confirm'
import Toast from 'vux/src/components/toast'

const orderStatusConfig = {
  0: '请尽快点击支付，前往支付平台完成支付，以免与自己的爱车擦肩而过。',
  1: '现在正在等待厂商做最后的确认，您需要补全填写个人资料，以方便后续签约流程的顺利进行。美好房车生活只差一步啦.',
  2: '您的预定已成功，请保持订购人手机开机畅通，我们的专属客服人员会在24小时内与您联系线下签约流程。房车生活即将开始，做好准备了吗？',
  4: '线下签约',
  5: '您的预定已成功，请保持订购人手机开机畅通，我们的专属客服人员会在24小时内与您联系线下签约流程。房车生活即将开始，做好准备了吗？'
}

export default {
  components: {
    Process,
    Confirm,
    Toast
  },
  data: () => ({
    statusList: orderStatusConfig,
    order: null,
    show: false,
    showMsg: false,
    msgTxt: ''
  }),
  methods: {
    async getDetail () {
      const { order_no } = this.$route.query
      const res = await OrderService.getDetail({ order_no })
      if (res.data.code === 1) {
        this.order = res.data.data
      }
    },
    // 取消订单?
    onCancleClick () {
      // todo 待完善
      this.show = true
    },
    onConfirm () {
      this.doCancle()
    },
    // 执行取消订单
    doCancle () {
      const { order_no } = this.order
      OrderService.doCancle({ order_no }).then(res => {
        // todo toast 提示
        if (res.data.code === 1) {
          this.showMsg = true
          this.msgTxt = '订单已取消'
          // 重新获取订单信息
          this.getDetail()
        } else {
          this.showMsg = true
          this.msgTxt = res.data.msg
        }
      })
    },
    remarkFil (val) {
      for (var key in this.statusList) {
        if (key * 1 === val * 1) {
          return this.statusList[key]
        }
      }
    },
    telBtn () {
      // console.log(22)
      window.location.href = 'tel:' + this.order.customer_tel
    },
    goPayPage () {
      console.log('pay')
      const { order_no } = this.order
      this.$router.push({ name: 'OrderPay', query: { order_no } })
    },
    goAdditionalInfo () {
      const { order_no } = this.order
      this.$router.push({ name: 'OrderAdditional', query: { order_no } })
    }
  },
  created () {
    this.getDetail()
  }
}
</script>

<style lang="css" scoped>
</style>
